import { defineFeature } from '../define-feature';
import { SeoSpaceTab, seoSpaceWebPath } from '../../seo/seo-space-routes';
import { SEO_PACK_PRICING as P } from './seo-pack-pricing';

export default defineFeature({
  id: 'marketing.seo_pack.options',
  category: 'marketing',
  title: 'Aller plus loin : doubler les articles, liens supplémentaires, accélérateur',
  intent: `Augmenter la cadence du pack quand on veut aller plus vite : 4 articles par semaine, jusqu'à ${P.extra_backlink_max} liens partenaires supplémentaires par mois, ou un accélérateur de ${P.accelerator_months} mois.`,
  context: {
    why: "Le pack couvre le rythme de croisière. À un lancement de site, une saison ou une migration, on veut parfois accélérer : plus d'articles pour couvrir plus de requêtes, plus de liens pour gagner en autorité plus vite. Trois offres, toutes sans engagement, toutes effectives le 1er du mois suivant, à activer depuis l'espace référencement ou la page Abonnement.",
    use_cases: [
      'Doubler les articles pour couvrir un catalogue large ou plusieurs villes.',
      'Prendre 2 liens supplémentaires par mois pendant une saison forte.',
      `Lancer l'accélérateur ${P.accelerator_months} mois au lancement d'un nouveau site.`,
    ],
  },
  required_scopes: ['website.seo_articles'],
  prerequisites: [
    {
      ref: 'marketing.seo_pack.overview',
      requirement: 'required',
      why: 'Les options ne se proposent que sur un pack actif (formule Max, parcours d’activation suivi).',
    },
  ],
  ui_entry_points: [
    { route: seoSpaceWebPath(SeoSpaceTab.ARTICLES), element: 'Onglet « Articles », section « Aller plus loin »' },
    {
      route: seoSpaceWebPath(SeoSpaceTab.BACKLINKS),
      element: `Onglet « Backlinks », sections « Liens supplémentaires » et « Accélérateur ${P.accelerator_months} mois »`,
    },
  ],
  api: {
    primary_operation_id: 'SeoContentAppController_upsell',
    related_operation_ids: [
      'SeoContentAppController_pack',
      'ProSubscriptionAppController_previewAddonChange',
      'ProSubscriptionAppController_activateAddon',
      'ProSubscriptionAppController_deactivateAddon',
    ],
  },
  steps: [
    `**Doubler mes articles** (${P.articles_double} par mois) : 4 articles par semaine au lieu de 2, à partir du 1er du mois suivant ; vos réglages passent à 4 jours de publication.`,
    `**Liens supplémentaires** (${P.extra_backlink} par lien et par mois, de 1 à ${P.extra_backlink_max}) : chaque mois, un article de plus sur vous publié sur un site de votre secteur. À partir du 1er du mois suivant, sans engagement.`,
    `**Accélérateur ${P.accelerator_months} mois** (${P.accelerator}, payé une fois) : ${P.accelerator_links_per_month} liens par mois pendant ${P.accelerator_months} mois, démarre le 1er du mois suivant, se cumule avec les liens supplémentaires. Un seul accélérateur à la fois, rachetable dès qu'il est terminé.`,
    `**Une demande particulière ?** (plus de ${P.max_backlinks_per_month} liens par mois, lien vers un autre site, sujet imposé) : le lien en bas de l'onglet ouvre une demande au support, sans tarif affiché.`,
  ],
  gotchas: [
    "**Tout démarre le 1er du mois suivant, jamais au prorata** : une option activée en octobre produit à partir de novembre et apparaît au prix plein sur la facture de votre prochaine échéance (décalage d'au plus un mois entre facture et livraison, dans un sens ou l'autre).",
    '**Sans engagement, même sur une formule engagée 12 mois** : résiliation à tout moment, effet à la fin de la période déjà facturée ; ce qui est facturé est livré, rien n’est remboursé.',
    "**Si votre abonnement Max s'arrête**, les options sont désactivées à la confirmation du changement et l'accélérateur est coupé au 1er suivant : liens restants perdus, sans remboursement.",
    `**Plafond : ${P.max_backlinks_per_month} liens par mois** (1 du pack + ${P.extra_backlink_max} supplémentaires + ${P.accelerator_links_per_month} de l'accélérateur).`,
    '**Prix hors taxes** ; la TVA dépend de votre régime, le montant TTC est affiché à la confirmation.',
    "**Ces options n'apparaissent pas à la première souscription** : elles s'activent une fois le pack actif.",
  ],
  related_features: [
    'marketing.seo_pack.overview',
    'marketing.seo_pack.backlinks',
    'marketing.seo_pack.topics',
    'account.subscription.manage',
  ],
});
